{
  "unauthorizedRoute": {
    "subtitle": "You do not have permission to access this page",
    "title": "Unauthorized"
  },
  "pageNotFound": "Page not found",
  "httpStatusCodes": {
    "400": {
      "title": "Bad request error",
      "subtitle": "A bad request error occurred, please check your data and retry.",
      "codes": {
        "INVALID_VALUE_NOT_NULL": "The field \"{field}\" is required.",
        "JSON_NOT_VALID": "The content is not in a valid JSON format.",
        "SCHEMA_NOT_MATCH": "The content does not correspond to the expected pattern.",
        "SCHEMA_NOT_MATCH_FIELD": "The content does not match the expected schema, error on the \"{field}\" property.",
        "CERTIFICATE_RENEWAL_FAILED_NO_DNS_MATCH": "The DNS & CN do not match the certificate configuration."
      }
    },
    "409": {
      "title": "Conflict error",
      "subtitle": "A conflict error occurred, please check your data and retry.",
      "codes": {
        "UNICITY_CONSTRAINT": "The value of field \"{field}\" is already used.",
        "UNICITY_CONSTRAINT_FIELD_LOGIN": "The login is already used.",
        "UNICITY_CONSTRAINT_FIELD_EMAIL": "The email is already used.",
        "UNICITY_CONSTRAINT_FIELD_NAME_ORGANIZATION": "The organization name is already used.",
        "UNICITY_CONSTRAINT_FIELD_USER_GROUP": "A user group with that name already exists.",
        "UNICITY_CONSTRAINT_FIELD_USER_PROFILE": "A profile with that name already exists."
      }
    },
    "404": {
      "title": "Not found",
      "subtitle": "Resource was not found."
    },
    "401": {
      "title": "unauthorized",
      "subtitle": "You are not logged in."
    },
    "403": {
      "title": "Forbidden",
      "subtitle": "You are not allowed to do this action.",
      "codes": {
        "SECTOR_DEPTH_EXCEEDED": "The sector maximum depth cannot exceed {maximum_allowed_depth}.",
        "SECTOR_DELETE_FORBIDDEN": "The sector cannot be deleted because some devices are attached to it."
      }
    },
    "500": {
      "title": "An error occurred",
      "subtitle": "Please try again another time."
    },
    "405": {
      "title": "Not allowed",
      "subtitle": "You are not allowed to do this action."
    },
    "408": {
      "title": "We could not load the page",
      "subtitle": "The request took too much time."
    }
  },
  "download": {
    "noData": "No data to download"
  }
}
